import React from 'react';
import { content } from './SellerLabel.style';
import Box from '@mui/material/Box';
import { FrenchFlagIcon } from '@next-common/shared-svg';
export const SellerLabel = ({ label, isFrench }) => {
    return (React.createElement(Box, { component: "span", sx: content, "data-qa": "seller-label" },
        React.createElement(Box, { component: "span" }, label),
        isFrench && (React.createElement(Box, { marginLeft: "4px", display: "flex", alignItems: "center" },
            React.createElement(FrenchFlagIcon, { width: "15", height: "9" })))));
};
